import apiService from './api';
import { ManagerDTO } from '../types/manager'; // Предполагаем, что этот DTO будет в types/manager.ts

const MANAGER_BASE_PATH = '/manager';

export const managerService = {
  getAllManagers: async (): Promise<ManagerDTO[]> => {
    const response = await apiService.get<ManagerDTO[]>(`${MANAGER_BASE_PATH}/all`);
    return response.data;
  },

  getAllCurators: async (): Promise<ManagerDTO[]> => {
    const response = await apiService.get<ManagerDTO[]>(`${MANAGER_BASE_PATH}/all/curator`);
    return response.data;
  },
  // Здесь могут быть другие методы для работы с менеджерами
};

export const { getAllManagers, getAllCurators } = managerService;
